/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Nameplaceholder1Inputs */

const zh_profile_nameplaceholder1 = /** @type {(inputs: Profile_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入姓名`)
};

const en_profile_nameplaceholder1 = /** @type {(inputs: Profile_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your name`)
};

const es_profile_nameplaceholder1 = /** @type {(inputs: Profile_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu nombre`)
};

/**
* | output |
* | --- |
* | "Enter your name" |
*
* @param {Profile_Nameplaceholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const profile_nameplaceholder1 = /** @type {((inputs?: Profile_Nameplaceholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Nameplaceholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_nameplaceholder1(inputs)
	if (locale === "en") return en_profile_nameplaceholder1(inputs)
	return es_profile_nameplaceholder1(inputs)
});
export { profile_nameplaceholder1 as "profile_namePlaceholder" }